<template>
  <v-data-table
    :headers="headers"
    :items="data"
    hideDefaultFooter
    class="elevation-1"
  >
    <template v-slot:item.status="{ item }">
      <v-chip :color="getColor(item.status)" dark>
        <!-- <v-icon v-if="!item.status">mdi-check-bold</v-icon>
        <span v-else>{{ item.status }}</span> -->
        <span>{{ convertMinutes(item.minutes) }}</span>
      </v-chip>
    </template>
    <template v-slot:item.listOffline="{ item }">
      <history-offline 
        v-if="item.listOffline"
        :playerID="item.id"
        :playerName="item.name"
      />
      <!-- <v-btn
        v-if="item.listOffline"
        rounded
        dark
      >
        <v-icon
          style="margin-right: 5px"
        >mdi-timeline-clock-outline</v-icon> {{ $t('common.history') }}
      </v-btn> -->
    </template>
  </v-data-table>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import api from '@/services/api'
  import HistoryOffline from './HistoryOffline'
  export default {
    name: 'StatusTable',
    components: {
      HistoryOffline
    },
    data () {
      return {
        page: 1,
        count: 0,
        itemPerPage: 10,
        searchValue: '',
        data: [],
        headers: [
          {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'Status', value: 'status' },
          { text: 'Últ.Con.', value: 'lcd' },
          { text: '', value: 'listOffline' },
        ],
      }
    },
    computed: {
      ...mapState('app',['enterpriseID']),
    },
    watch: {
      'enterpriseID': {
        handler: function (newValue) {
          this.getStatus(newValue)
        },
        deep: true
      }
    },
    mounted () {
      this.getStatus(this.enterpriseID)
    },
    methods: {
      getStatus (enterpriseID) {
        api.getAll(`pings/${enterpriseID}`, true, this.page, this.itemPerPage, this.searchValue).then(response => {
          this.count = response.count
          this.data = response.data.map(item => {
            const a = item.Time.split(':')
            const minutes = (+a[0]) * 60 + (+a[1])
            return ({
              id: item.ID,
              name: item.Name,
              status: minutes > item.Delay ? true : false,
              minutes: minutes,
              lcd: `${new Date(item.LCD).toLocaleDateString()} ${new Date(item.LCD).toLocaleTimeString()}`,
              listOffline: item.ListOffline
            })
          })
          this.loading = false
        })
      },
      getColor (status) {
        if (status) return 'red'
       //else if (status > 200) return 'orange'
        else return 'green'
      },
      convertMinutes(value) {
        const d = Math.floor(value/1440) // 60*24
        const h = Math.floor((value-(d*1440))/60)
        const m = Math.round(value%60)

        if(d>0) {
          return `${d} d, ${h} h, ${m} m`
        } else if(h>0) {
          return `${h} h, ${m} m`
        }
        else {
          return `${m} min`
        }
      }
    }
  }
</script>

<style scoped>
  .main {
    padding: 15px;
  }
</style>
